import { useMemo } from 'react';
import { Dropdown } from 'react-bootstrap';
import { BrandFavicon } from '../BrandFavicon';
import { useProject } from '../../context/ProjectContext';
import { useProjectCompetitors } from '../../hooks/useProjectCompetitors';
import { FilterChip, FilterMenuItem, DomainIcon } from './FilterChip';

export function DomainFilter() {
  const { projectId, data, domainFilterId, setDomainFilterId } = useProject();
  const competitors = useProjectCompetitors(projectId);

  const trackingDomains = useMemo(
    () => (data?.insight.domains ?? []).filter((domain) => domain.isTrackingSource),
    [data?.insight.domains],
  );

  const primaryDomain =
    trackingDomains.find((domain) => domain.isPrimary) ?? trackingDomains[0] ?? null;

  const selectedCompetitor =
    domainFilterId !== 'all' && domainFilterId !== 'you'
      ? competitors.find((item) => item.id === domainFilterId)
      : null;

  const label = useMemo(() => {
    if (domainFilterId === 'you') {
      return primaryDomain?.displayName ?? primaryDomain?.host ?? 'برند شما';
    }
    if (selectedCompetitor) return selectedCompetitor.brandName;
    return 'همه دامنه‌ها';
  }, [domainFilterId, primaryDomain, selectedCompetitor]);

  const isActive = domainFilterId !== 'all';

  const chipIcon = useMemo(() => {
    if (domainFilterId === 'you' && primaryDomain) {
      return (
        <BrandFavicon
          host={primaryDomain.host}
          name={primaryDomain.displayName ?? primaryDomain.host}
          size="xs"
        />
      );
    }
    if (selectedCompetitor) {
      return (
        <BrandFavicon
          host={selectedCompetitor.host}
          name={selectedCompetitor.brandName}
          size="xs"
        />
      );
    }
    return <DomainIcon />;
  }, [domainFilterId, primaryDomain, selectedCompetitor]);

  if (!trackingDomains.length && !competitors.length) return null;

  return (
    <FilterChip icon={chipIcon} label={label} active={isActive} align="end">
      <FilterMenuItem
        selected={domainFilterId === 'all'}
        onClick={() => setDomainFilterId('all')}
      >
        همه دامنه‌ها
      </FilterMenuItem>

      {trackingDomains.length > 0 && (
        <FilterMenuItem
          selected={domainFilterId === 'you'}
          onClick={() => setDomainFilterId('you')}
          leading={
            primaryDomain ? (
              <BrandFavicon
                host={primaryDomain.host}
                name={primaryDomain.displayName ?? primaryDomain.host}
                size="xs"
              />
            ) : undefined
          }
        >
          برند شما
        </FilterMenuItem>
      )}

      {competitors.length > 0 && (
        <>
          <Dropdown.Divider />
          {competitors.map((competitor) => (
            <FilterMenuItem
              key={competitor.id}
              selected={domainFilterId === competitor.id}
              onClick={() => setDomainFilterId(competitor.id)}
              leading={
                <BrandFavicon
                  host={competitor.host}
                  name={competitor.brandName}
                  size="xs"
                />
              }
            >
              {competitor.brandName}
            </FilterMenuItem>
          ))}
        </>
      )}
    </FilterChip>
  );
}
